<template>
  <div class="content">
    <Modal
      v-model="showModal"
      title="关联课程"
      @on-ok="confirm"
      @on-cancel="cancel"
      :loading="$root.$children[0].modalLoading"
      width="1050"
      class="my-modal top"
    >
      <div class="search-box gauge_20">
        <div class="input-item">
          <span class="label">课程分类</span>
          <Select v-model="search.courseColumnId" placeholder="请选择" filterable clearable>
            <Option :value="item.id" v-for="(item, index) in menuList" :key="index">
              {{ item.name }}
            </Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">课程名称</span>
          <Input v-model="search.name" placeholder="请输入" />
        </div>

        <div class="btn-item">
          <Button type="primary" @click="searchAjax(1)">搜索</Button>
        </div>
      </div>
      <p class="total">
        <span> <Checkbox v-if="tableData.length" :value="isAll" @on-change="checkAll"> </Checkbox>全部课程</span>
        <span
          >已选择<b>{{ list.length }}</b
          >项,共<b>{{ tableData.length }}</b
          >款课程</span
        >
      </p>
      <div class="table-box template-table">
        <loading :isShow="tableLoading" />
        <Table :columns="columns" :data="tableData" border :max-height="400" @on-cancel="cancel" @on-selection-change="select">
          <template slot-scope="{ row }" slot="courseId">
            <Checkbox :value="isCheck(row.courseId)" @on-change="check(row.courseId)"> </Checkbox>
          </template>
          <template slot-scope="{ row }" slot="articleType">
            <span>{{ articleType[row.articleType] }}</span>
          </template>
        </Table>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  components: {},
  computed: {
    isAll() {
      return this.tableData.length == this.list.length;
    }
  },
  data() {
    return {
      menuList: [],
      showModal: false,
      tableLoading: false, //表格loading
      columns: [
        //表格字段
        {
          title: '  ',
          slot: 'courseId',
          align: 'center',
          width: 100
          // type: "selection"
        },
        {
          title: '课程类型',
          slot: 'articleType',
          align: 'center',
          width: 250
        },
        {
          title: '课程名称',
          key: 'name',
          align: 'center'
        },
        {
          title: '是否上架',
          slot: 'isUse',
          align: 'center',
          width: '180',
          render(h, params) {
            return <span>{params.row.isUse == 0 ? '否' : '是'}</span>;
          }
        }
      ],
      tableData: [], //表格数据
      total: 0, //表格记录数
      pageSize: 999, //页容量
      pageNum: 1, //当前页
      search: {},
      list: [],
      selctedList: [],
      articleType: {}
    };
  },
  created() {
    this.getMenuList();
    try {
      let articleType = JSON.parse(localStorage.getItem('dic'))['TRAIN_ARTICLE_TYPE'];
      this.articleType = articleType;
    } catch (e) {
      //TODO handle the exception
    }
  },
  methods: {
    checkAll() {
      if (this.isAll) {
        this.list = [];
      } else {
        this.list = this.tableData.map(i => i.courseId);
      }
    },
    check(courseId) {
      if (this.list.includes(courseId)) {
        let idx = this.list.findIndex(i => i == courseId);
        this.list.splice(idx, 1);
      } else {
        this.list.push(courseId);
      }
    },
    isCheck(id) {
      return this.list.includes(id);
    },
    getMenuList() {
      this.$http({
        url: `/buz/courseColumn/read/list`,
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999
        }
      })
        .then(res => {
          this.menuList = res.data;
        })
        .catch(e => {});
    },
    select(res) {
      this.list = res.map(i => i.courseId);
    },
    confirm() {
      if (this.list.length == 0) {
        this.$notice
          .inquiry('您还没有选择课程，是否保存？')
          .then(() => {
            this.showModal = false;
          })
          .catch(() => {
            console.log(this.$root.$children[0]);
            this.$units.notCloseModal(this);
          });
      } else {
        this.$http({
          url: `/buz/testCenter/select/course`,
          type: 'POST',
          data: {
            testId: this.id,
            courseIdList: this.list
          }
        })
          .then(res => {
            this.$notice.success('操作成功');
            this.$emit('sel', []);
            this.showModal = false;
          })
          .catch(e => {
            this.tableLoading = false;
          });
      }
    },
    cancel() {},
    getParams() {
      const params = Object.assign({}, this.search);
      return params;
    },
    reset() {
      this.search.courseColumnId = '';
      this.search.name = '';
      this.searchAjax();
    },
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      const params = this.getParams();
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      this.tableLoading = true;
      this.$http({
        url: `/buz/testCenter/optional/course/${this.id}`,
        type: 'POST',
        data: params
      })
        .then(res => {
          this.tableLoading = false;
          this.tableData = res.data;
          this.total = res.total;
          this.list = [];
        })
        .catch(e => {
          this.tableLoading = false;
        });
    },
    open(id, list = []) {
      this.selctedList = list;
      if (id) {
        this.id = id;
        this.reset();
      }
      this.showModal = true;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-modal-body {
  padding-bottom: 90px !important;
}
/deep/.ivu-select {
  display: unset;
  overflow: unset !important;
}
.total {
  margin: 0 0 15px;
  display: flex;
  justify-content: space-between;
  b {
    color: #236dff;
    font-weight: 400;
    padding: 0 2px;
  }
}
.btn-item {
  position: unset;
}

.icon-check {
  width: 16px;
  cursor: pointer;
}

/deep/.search-box {
  /* height: 40px; */
  position: relative;
  padding-right: 0;
  margin-top: 10px;

  .input-item {
    width: 45%;
    padding-right: 4%;
  }
}

.main-panel {
  height: 40px;
  position: relative;

  .table-box {
    .key-name {
      font-weight: bold;
      font-size: 14px;
    }

    .key-id {
      font-size: 12px;
      color: #a8adb7;
    }
  }
}
</style>
